import React, { useState } from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faLink } from '@fortawesome/pro-light-svg-icons';
import { FormDialog } from '../form-dialog';

export interface IChatInfoModalProps {
  text: string;
  url: string;
  title: string;
  hideExternalLink?: boolean;
}

export function ChatInfoModal(props: IChatInfoModalProps) {
  const { text, url, title, hideExternalLink } = props;

  const [isOpen, setIsOpen] = useState(false);

  function cleanText(textInput: string) {
    // Replace tabs with single spaces
    let temp = textInput.replace(/\t+/g, ' ');

    // Replace multiple spaces with a single space
    temp = temp.replace(/\s{2,}/g, '\n\n');

    // Replace multiple consecutive newlines with a single newline
    temp = temp.replace(/(\n\s*){2,}/g, '\n');
    temp = temp.replace(/(^|\n)(\d)/g, '\n\n$2');

    return temp.trim();
  }

  const Title = (
    <Box display="flex" alignItems="center" gap={1}>
      {title}
      {!hideExternalLink && (
        <Tooltip title={`Åben den fulde version af '${title}' `}>
          <IconButton size="small" onClick={() => window.open(url, '_blank')} aria-label={`Åbn ${title} (åbner i nyt vindue)`}>
            <FontAwesomeIcon icon={faLink} size="xs" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );

  return (
    <div>
      <Box display="flex" alignItems="center" gap={0}>
        {!hideExternalLink ? (
          <Tooltip title={`Åben den fulde version af '${title}' `}>
            <a href={url} target="_blank" rel="noreferrer" aria-label={`${title} (åbner i nyt vindue)`}>
              {title}
            </a>
          </Tooltip>
        ) : (
          <span>{title}</span>
        )}
        <Tooltip title="Vis detaljer">
          <IconButton size="small" onClick={() => setIsOpen(true)} aria-label="Vis detaljer">
            <FontAwesomeIcon icon={faCircleInfo} size="xs" />
          </IconButton>
        </Tooltip>
      </Box>

      <FormDialog
        open={isOpen}
        title={Title}
        confirmButtonText="Luk"
        cancelButtonText="Luk"
        maxWidth="xl"
        onConfirmClick={() => setIsOpen(false)}
        sx={{
          '& .MuiDialogTitle-root': {
            py: 2,
          },
          '& .MuiDialogContent-root': {
            maxHeight: 'calc(100vh - 197px)',
            overflow: 'auto',
          },
          '& .MuiDialogActions-root': {
            pt: 2,
          },
        }}
      >
        <Box>
          <Box minWidth={800}>
            <Typography style={{ whiteSpace: 'pre-line', fontSize: '12px' }}>{cleanText(text)}</Typography>
          </Box>
        </Box>
      </FormDialog>
    </div>
  );
}
